import { object, bool, array, func } from 'prop-types'
import { LabeledSelect, kuiperClassNames } from '@opallabs/kuiper'
import { AnalyticsLayer } from '@opallabs/quanta'

import './styles.scss'

const ChannelAndAccount = ({
  channels,
  onChannelSelect,
  selectedChannel = {},
  validChannel = false,
}) => (
  <div className={kuiperClassNames('channel-and-account')}>
    <AnalyticsLayer name="Channel & Account Dropdowns">
      <AnalyticsLayer name="Content Type Select">
        <LabeledSelect
          className="channel-account-select"
          labelText="Content Type"
          onSelect={onChannelSelect}
          options={channels}
          placeholder="Choose Content Type"
          truncateValueAt={28}
          value={selectedChannel}
          valid={validChannel}
        />
      </AnalyticsLayer>
    </AnalyticsLayer>
  </div>
)
ChannelAndAccount.displayName = 'Photon: ChannelAndAccount'

ChannelAndAccount.propTypes = {
  channels: array,
  onChannelSelect: func.isRequired,
  selectedChannel: object,
  validChannel: bool,
}

export default ChannelAndAccount
